export enum TipoOrdenacaoCardapio {
    PorPrecoMenorParaMaior = 0,
    PorNome = 1
}